
import * as types from '../constants/actionTypes';

function messaging(state = {
  messages: [],
  message: null,
  minHeight: (window.screen.height - 50),
  dimensions: {
    clientHeight: 0,
    innerHeight:0,
    outerHeight: 0,
    screenHeight: 0
  },
  showMessage: false,
  newMessagesArray: [],
  globalNewMessageCount: 0
  }, action) {

   switch (action.type) {

    case types.RECIEVE_MESSAGES:

          var counter = 0;
          
          var someVal = action.messages.map((message) => {
            counter += ((message.NewMessage || message.NewMessages > 0) ? 1 : 0);
          });

          return Object.assign({}, state, {
            messages: action.messages,
            globalNewMessageCount: counter
          });

    case types.RECEIVE_MESSAGE:
      return {
        ...state,
        messages: [
          action.message,
          ...state.messages
        ],
        message: {
          ...action.message,
          replies: []
        }
      };

    case types.SHOW_MESSAGE:
      return {
        ...state,
        message: action.message,
        showMessage: true
      }

    case types.SHOW_MESSAGES:
         return {
        ...state,
        showMessage: false
      }

    case types.NEW_MESSAGE:
      return {
        ...state,
        message: null,
        showMessage: true
      }

    case types.SELECT_A_TOPIC:
      return {
        ...state,
        message: {
          SystemMessageID: 0,
          SystemMessageLogID: 0,
          Subject: action.text,
          Message: "",
          SystemMessageTopicID: action.id
        }
      }


    case types.ADD_MESSAGE_REPLY:
    case types.RECEIVE_PHOTO: {
      let index = state.message.replies.map(r => r.SystemMessageReplyID).indexOf(action.reply.SystemMessageReplyID)
      if(index === -1){
        return {
          ...state,
          message: {
            ...state.message,
            replies: [
              ...state.message.replies,
              action.reply
            ]
          }
        };
      }
      else {
        let replies = [...state.message.replies]
        replies[index] = action.reply;
        return {
          ...state,
          message: {
            ...state.message,
            replies: [...replies]
          }
        };
      }

    }

    case types.CLEAR_THE_DOT:
      
        return Object.assign({}, state, {
          messages: state.messages.map((message) => {
            if (message.SystemMessageID === action.id) {
              return Object.assign({}, message, {
                NewMessage: false,
                NewMessages:0
              })
            }
            return message
          })
        })

    case types.INDICATE_NEW_MESSAGE:
      
        return Object.assign({}, state, {
          messages: state.messages.map((message) => {
            if (message.SystemMessageLogID === action.message.SystemMessageLogID) {
              return Object.assign({}, message, {
                NewMessage: true,
                Message: action.message.Message
              })
            }
            return message;
          })
        })


        
    case types.FIX_MESSAGE:
      
      return {
        ...state,
        message: {
          ...state.message,
          replies: state.message.replies.map((reply) => {
            if (reply.SystemMessageReplyID === action.message.SystemMessageReplyID) {
              return Object.assign({}, reply, {
                Message: action.message.NewMessage
              })
            }
            return reply;
          })
        }
      };

      case types.DELETE_MESSAGE_REPLY:

        var newReplies = state.message.replies.filter((r) => {
          return (r.SystemMessageReplyID !== action.replyId);
        })

        return {
          ...state,
          message: {
            ...state.message,
            replies: newReplies        
          }
        }
      break;



      case types.APPEND_NEW_MESSAGE:
      
        return Object.assign({}, state, {
          messages: state.messages.map((message) => {
            
            if (message.SystemMessageLogID === action.message.SystemMessageLogID) {
              return Object.assign({}, message, {
                Message: action.message.Message,
                NewMessage: (!state.showMessage),
                Attachment:  action.message.Attachment
              })
            }

            return message
          })
        })

    case types.UPDATE_GLOBAL_NEW_MESSAGE_COUNT:
      
      var counter = 0;
            
      var someVal = state.messages.map((message) => {
        counter += ((message.NewMessage || message.NewMessages > 0) ? 1 : 0);
      });

      return Object.assign({}, state, {
        messages: state.messages,
        globalNewMessageCount: counter
      });
        

    case types.RECEIVE_MESSAGE_REPLIES:
      
      return {
        ...state,
        message: {
          ...state.message,
          replies: action.replies              
        } 
      }

    case types.SET_MIN_HEIGHT:
      
      return {
        ...state,
        minHeight: action.height
      }

    case types.SET_DIMENSIONS:
      
      return {
        ...state,
        dimensions: action.dimensions
        //minHeight: action.height
      }
      
    default:
      return state;
  }
  
}

export default messaging



// WEBPACK FOOTER //
// ./src/reducers/messaging.js